import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../../config';

export default function useProductionOrderLookup(onFound) {
  const [message, setMessage] = useState('');
  const version = useRef(0);
  const timer = useRef(null);
  const apply = useRef(onFound);
  apply.current = onFound;
  const cancel = () => {
    version.current += 1;
    clearTimeout(timer.current);
    setMessage('');
  };
  useEffect(
    () => () => {
      version.current += 1;
      clearTimeout(timer.current);
    },
    [],
  );
  const search = (value) => {
    cancel();
    const number = value.trim();
    if (!/^\d{1,9}$/.test(number)) return;
    const request = version.current;
    timer.current = setTimeout(async () => {
      setMessage('Sprawdzanie zlecenia…');
      try {
        const { data } = await axios.get(
          `${API_URL}/reports-pz04/production-order/${encodeURIComponent(
            number,
          )}`,
          { withCredentials: true },
        );
        if (version.current !== request) return;
        if (!data) {
          setMessage('Nie znaleziono zlecenia. Uzupełnij dane ręcznie.');
          return;
        }
        setMessage(apply.current(data));
      } catch {
        if (version.current === request)
          setMessage('Nie udało się pobrać zlecenia. Uzupełnij dane ręcznie.');
      }
    }, 500);
  };
  return { search, cancel, message };
}
